import { render } from "./dashboardTopClients.vue?vue&type=template&id=668c860e&scoped=true"
import script from "./dashboardTopClients.vue?vue&type=script&lang=js"
export * from "./dashboardTopClients.vue?vue&type=script&lang=js"

import "./dashboardTopClients.vue?vue&type=style&index=0&id=668c860e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668c860e"]])

export default __exports__